var Ripple = require('ripple-lib')
var constants = require('./constants')

var ripple = exports['nodes'] = new Ripple.Remote({
   servers: [
  {
    host: 'peer.rmc.one',
    port: 443,
    secure: true
  },
  {
    host: 'alpha.rmc.one',
    port: 443,
    secure: true
  },
  {
    host: 'beta.rmc.one',
    port: 443,
    secure: true
  },
  {
    host: 'gamma.rmc.one',
    port: 443,
    secure: true
  }]
})

ripple.connect()



//////////////////
// WEBPACK FOOTER
// ./src/helpers/remotes.js
// module id = 351
// module chunks = 0